import { hooks } from '../hooks';
import { custom } from '../custom';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import React, { useState } from 'react';

// You would define these in a separate configuration file
const SHOPIFY_STOREFRONT_API_URL = 'https://festivehq.myshopify.com/api/2025-07/graphql.json'; 
const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'ac806dacb44ae4d1b1387f7b89eddef5';



export const ForgotPassword: React.FC = () => {
  const navigate = hooks.useAppNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  

  const renderHeader = () => {
    return <components.Header goBack={true} />;
  };

  const renderContent = () => {
    return (
      <div style={{
        textAlign: 'center',
        fontSize: '24px',
        fontWeight: 'bold',
        color: theme.colors.mainColor,
        margin: '0 0 18px 20px',
        letterSpacing: 1,
        ...theme.fonts.Mulish_700Bold,
      }}
      ><h2>Forgot Password</h2>
        <div style={{ padding: '30px 20px 20px 20px' }}>
          <p
            style={{
              margin: 0,
              marginBottom: 40,
              color: theme.colors.textColor,
              lineHeight: 1.5,
              marginRight: 20,
              ...theme.fonts.Mulish_400Regular,
              fontSize: 14,
            }}
          >
            Please enter your email address. You will receive a password reset link.
          </p>
          <custom.InputField
            label='Email'
            icon={<svg.InputCheckSvg />}
            placeholder='zenithsneaks@mail.com'
            containerStyle={{ marginBottom: 20 }}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
       <components.Button
  title={isLoading ? 'Sending...' : 'Send'}
  onClick={handleSendPasswordReset}
  disabled={isLoading}
/>
        </div>
      </div>
    );
  };

const handleSendPasswordReset = async () => {
    if (!email) {
      alert('Please enter your email.');
      return;
    }

    setIsLoading(true);

 const query = `
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        field
        message
      }
    }
  }
`;

    try {
      const response = await fetch(SHOPIFY_STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '223e6f6958a6e1568db68d8891388212',
        },
        body: JSON.stringify({
          query,
          variables: { email },
        }),
      });

      const data = await response.json();

      if (data.errors || (data.data && data.data.customerRecover.customerUserErrors.length > 0)) {
        // Handle specific errors from Shopify by logging them
        console.error('Shopify API Error:', data.data?.customerRecover?.customerUserErrors || data.errors);
        
        // Display a generic message to the user for security
        alert('If an account with that email exists, a password reset link has been sent.');
      } else {
        // Success
        alert('Password reset link sent to your email!');
        navigate('/Signin');
      }
    } catch (error) {
      console.error('Network or API call failed:', error);
      alert('Failed to send password reset.');
    } finally {
      setIsLoading(false);
    }
};

  const renderBottomTabBar = () => {
    return <components.BottomTabBar />;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};